export function noop(value) {
    return value;
}

export function curry(fn, n = fn.length) {

    if (n <= 1) {
        return fn;
    }

    return function (x) {
        return curry(function (...args) {
            return fn(x, ...args);
        }, n - 1);
    }
}

export function compose(fn: Function, ...fns: Function[]) {
    return function (...args) {
        return fns.reduce((acc, f) => f(acc), fn(...args));
    }
}